import { Form, Grid } from "antd";
import { useForm } from "antd/es/form/Form";
import { useDebounceFn } from "src/hooks/useDebounce";
import { FC, useState } from "react";
import { useHotelsListingContext } from "../../context/HotelsListingContext";
import { SORTERS, INITIAL_SORTER_VALUE } from "src/Modules/Hotels/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import Sortersweb from "./layouts/SortersBar.web";
import SortersMob from "./layouts/SortersBar.mob";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { track } from "@amplitude/analytics-browser";

const SortersComponent = withConditionalComponent(Sortersweb, SortersMob);

const SortersBar: FC<{ dataGroups: any }> = ({ dataGroups }) => {
  const [form] = useForm();
  const { setSorter, isFetching, pointsFactor } = useHotelsListingContext();
  const [activeSorter, setActiveSorter] = useState<string>(Object.keys(INITIAL_SORTER_VALUE)?.[0]);
  const activeValue = form.getFieldValue(activeSorter);
  const debouncedUpdateFilters = useDebounceFn(setSorter, 200);

  const handleChange = (value: any) => {
    const key = Object.keys(value)?.[0];
    setActiveSorter(key);
    track("Sorter Updated", { ...value });
    debouncedUpdateFilters(value);
  };
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return (
    <Form className="m-0! p-0! flex" onValuesChange={handleChange} form={form} initialValues={INITIAL_SORTER_VALUE}>
      <SortersComponent
        trigger={isLargeScreen}
        props={{
          dataGroups,
          sorters: SORTERS,
          activeSorter,
          activeValue,
          className: "md:px-2! md:p-1!",
          isLoading: isFetching,
          pointsFactor,
        }}
      />
    </Form>
  );
};

export default SortersBar;


